<template>
  <ul class="eb-menu">
    <slot></slot>
    <!-- <li class="menu-item active">首页</li>
    <li class="menu-item">全部订单</li>
    <li class="menu-item">商品管理</li>
    <li class="menu-item">精选商品</li>
    <li class="menu-item">数据管理</li>
    <li class="menu-item">个人中心</li>-->
  </ul>
</template>

<script>
export default {
  name: 'EbMenu',
  props: {
    defaultActive: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
    activeTextColor: {
      type: String,
      default: '',
    },
    defaultOpeneds: {
      type: Array,
    },
  },
  data() {
    return {
      activeIndex: this.defaultActive,
      openedMenus: this.defaultOpeneds ? this.defaultOpeneds.slice(0) : [],
    };
  },
  provide() {
    return {
      rootMenu: this,
    };
  },
  watch: {
    defaultActive(value) {
      this.activeIndex = value;
    },
  },
  mounted() {
    this.$on('item-click', this.handleItemClick);
    this.$on('submenu-click', this.handleSubmenuClick);
  },
  methods: {
    handleItemClick(item) {
      const { index, route } = item;
      const hasIndex = item.index !== null;

      if (hasIndex) {
        this.activeIndex = item.index;
      }

      if (this.$router && this.$route.name !== route && route) {
        this.$router.push(route);
      }

      this.$emit('select', index, item);
    },
    handleSubmenuClick(submenu) {
      const { index } = submenu;
      const isOpened = this.openedMenus.indexOf(index) !== -1;

      if (isOpened) {
        this.closeMenu(index);
      } else {
        this.openMenu(index);
      }
    },
    openMenu(index) {
      const { openedMenus } = this;
      if (openedMenus.indexOf(index) !== -1) return;

      this.openedMenus.push(index);
    },
    closeMenu(index) {
      const i = this.openedMenus.indexOf(index);

      if (i !== -1) {
        this.openedMenus.splice(i, 1);
      }
    },
  },
};
</script>


<style lang="less">
.eb-menu [class^="eb-icon"] {
  margin-right: 6px;
}
</style>

<style lang="less" scoped>
</style>
